
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { SignalsService } from '../signals/signals.service';
import { RequestState } from '@shared/models/request-state';
import { ApiCacheService } from '../cache-service/api-cache.service';
import { ActivitySummaryResponse } from '@shared/models/activity-summary/activity-summary.response';
import { ErrorLogService } from '../errorhandler/error-log.service';

@Injectable({
  providedIn: 'root',
})
export class ActivityRecordService {

  
  private readonly _apiUrl = `${environment.apiUrl}/summary`;

  constructor(
    public signalService: SignalsService,
    private cacheService: ApiCacheService,
    private errorLogService: ErrorLogService
  ) {}


  getSummaryRecords(
    employeeNumber: string,
    year: number,
    period: number,
    isRefresh = false
  ): Observable<RequestState<ActivitySummaryResponse>> {
    const cacheId = this.addCacheId(employeeNumber, year, period);
    const url = `${this._apiUrl}/${employeeNumber}/${year}/${period}`;
    this.errorLogService.logError(`[ERROR] - ActivityRecordService URl ${url}`);

    if (!isRefresh) {
      //console.log("%cInitializing Flight Records...", "color: orange");
      return this.cacheService.request<ActivitySummaryResponse>(cacheId, url, undefined);
    } else {
      //console.log("%cInitializing Flight Totals Data...", "color: orange");
      return this.cacheService.forceRefreshGet<ActivitySummaryResponse>(
        cacheId,
        url
      );
    }
  }

  
  private addCacheId(employeeNumber: string, year: number, period: number): string {
    return `summaryrecord.${employeeNumber}.${year}${period}`
  }
}






















  //------------------------------- CALENDAR API - ACTIVE ------------------------------------ */






  // getActivityRecord(dateString: string, employeeNumber: string): Observable<RequestState<ActivitySummaryResponse>> {
  //   const year = DateTime.fromISO(dateString).year;
  //   const period = DateTime.fromISO(dateString).month
  //   const cacheId = this.getCacheId(year, period, employeeNumber);

  //   const url = `${this._summaryRecordApiUrl}/${employeeNumber}`;

  //   return this.cacheService.request<ActivitySummaryResponse>(cacheId, url)
  // }

  
  // refreshActivityRecord(dateString: string, employeeNumber: string): Observable<RequestState<ActivitySummaryResponse>> {
  //   const year = DateTime.fromISO(dateString).year;
  //   const period = DateTime.fromISO(dateString).month
  //   const cacheId = this.getCacheId(year, period, employeeNumber);
    
  //   const url = `${this._summaryRecordApiUrl}/${employeeNumber}`;

  //   return this.cacheService.forceRefreshGet<ActivitySummaryResponse>(cacheId, url);
  // }

  // private getCacheId(year: number, period: number, employeeNumber: string): string {
    
  //   return `summaryRecord-${employeeNumber}-${year}${period}`;
  // }

  // //------------------------------- OLD API - ACTIVE ------------------------------------ */

  //   fetchFlightSequencesAPI$ = this.oidcService.getAccessToken()
  //     .pipe(
  //       switchMap( (token) => {
  //         const httpOptions = {
  //           headers: new HttpHeaders({
  //             Authorization: 'Bearer ' + token,
  //           }),
  //         };
  //         this.signalService.isLoading$.set(true);
  //         // return this.http.get<ActivityRecordResponse[]>(`${this._url}ActivityRecord?startdate=2024-06-02&enddate=2024-08-14&${this._options}`, httpOptions)
  //         return this.http.get<ActivityRecordResponse[]>('./assets/dummyData/dummy-activityResponse.json')
  //           .pipe(
  //             map(response => this.cleanRecordResponse(response)),
  //             map(cleanedResponse => this.transformRecordResponse(cleanedResponse)),
  //             tap(data => {
  //               if (data.length === 0) {
  //                 this.signalService.isLoading$.set(false)
  //                 this.messageService.add({ severity: 'error', summary: `Error Occured while attemping download`, life: 5000 })
  //                 sessionStorage.removeItem('activityRecord');
  //                 return of(null)
  //               }
  //               else {
  //                 sessionStorage.setItem('activityRecord', JSON.stringify(data))
  //                 return data
  //               }
  //             }),
  //             //catchError(this.handleError)
  //             catchError((error) => {
  //               this.handleError
  //               this.messageService.add({ severity: 'error', summary: `Error Occured from Server: ${error.status}`, detail: `${error.message}`,life: 5000 })
  //               return of(null)
  //             })
  //           )
  //       })
  //     );

  // getFlightSequencesRange(beginDate: string, endDate: string): Observable<LogbookActivityRecordResponse[]> {
  //   return this.oidcService.getAccessToken()
  //     .pipe(
  //       switchMap((token) => {
  //         const httpOptions = {
  //           headers: new HttpHeaders({
  //             Authorization: 'Bearer ' + token,
  //           }),
  //         };
  //         this.signalService.isLoading$.set(true);
  //         return this.http.get<ActivityRecordResponse[]>(`${this._url}ActivityRecord?startdate=${beginDate}&enddate=${endDate}&${this._options}`, httpOptions)
  //         .pipe(
  //           map(response => this.cleanRecordResponse(response)),
  //           map(cleanedResponse => this.transformRecordResponse(cleanedResponse)),
  //           tap(data => {
  //             if (data.length === 0) {
  //               this.signalService.isLoading$.set(false)
  //               this.messageService.add({ severity: 'error', summary: `Error Occured while attemping download` })
  //               sessionStorage.removeItem('activityRecord');
  //               return of<LogbookActivityRecordResponse[]>([])
  //             }
  //             else {
  //               sessionStorage.setItem('activityRecord', JSON.stringify(data))
  //               return data
  //             }
  //           }),
  //           //catchError(this.handleError)
  //           catchError((error) => {
  //             this.handleError
  //             this.messageService.add({ severity: 'error', summary: `Error Occured from Server: ${error.status}` })
  //             return of<LogbookActivityRecordResponse[]>([])
  //           })
  //         )
  //       })
  //     );
  // }

  // getFlightSequencesByDate(dateString: string): Observable<LogbookActivityRecordResponse[]> {
  //   return this.oidcService.getAccessToken()
  //     .pipe(
  //       switchMap((token) => {
  //         const httpOptions = {
  //           headers: new HttpHeaders({
  //             Authorization: 'Bearer ' + token,
  //           }),
  //         };
  //         this.signalService.isLoading$.set(true);
  //         return this.http.get<ActivityRecordResponse[]>(`${this._url}ActivityRecord/${dateString}?${this._options}`, httpOptions)
  //         .pipe(
  //           map(response => this.cleanRecordResponse(response)),
  //           map(cleanedResponse => this.transformRecordResponse(cleanedResponse)),
  //           tap(data => {
  //             if (data.length === 0) {
  //               this.signalService.isLoading$.set(false)
  //               this.messageService.add({ severity: 'error', summary: `Error Occured while attemping download` })
  //               sessionStorage.removeItem('activityRecord');
  //               return of<LogbookActivityRecordResponse[]>([])
  //             }
  //             else {
  //               sessionStorage.setItem('activityRecord', JSON.stringify(data))
  //               return data
  //             }
  //           }),
  //           //catchError(this.handleError)
  //           catchError((error) => {
  //             this.handleError
  //             this.messageService.add({ severity: 'error', summary: `Error Occured from Server: ${error.status}` })
  //             return of<LogbookActivityRecordResponse[]>([])
  //           })
  //         )
  //       })
  //     );
  // }

  // cleanRecordResponse(response: ActivityRecordResponse[]): ActivityRecordResponse[] {
  //   const activityRecords = response;
  //   let cleanedActivityRecords = [];
  //   for (let activityRecord of activityRecords) {
  //     for (let activityItem of activityRecord.activityItems) {
  //       const contractualStartDate = getMonthDates(activityRecord.effectivePeriod.monthShortName).start;
  //       if (contractualStartDate) {
  //         if (new Date(activityItem.startDateTimeGmt) > new Date(contractualStartDate)) {
  //           cleanedActivityRecords.push(activityItem)
  //         }
  //       }
  //       else {
  //         let emptyActivityItems = activityRecord.activityItems = [];
  //         return emptyActivityItems;
  //       }
  //     }
  //     activityRecord.activityItems = cleanedActivityRecords
  //     cleanedActivityRecords = [];
  //   }
  //   return activityRecords;
  // }

  // /**Fetch dummy json data for testing */
  // // fetchFlightSequencesDummy$ = this.http.get<ActivityItemResponse>(`${this._url}ActivityRecord/${this.startDate}${this._options}`, httpOptions)
  // // .pipe (
  // //
  // //   catchError(this.handleError)
  // // )

  // transformRecordResponse(response: ActivityRecordResponse[]): LogbookActivityRecordResponse[] {
  //   let activityRecord: LogbookActivityRecordResponse[] = [];
  //   let timeStamp = ""
  //   for (let record of response) {
  //     //timeStamp = String(record.effectivePeriod.asInt);
  //     activityRecord.push({
  //       timestamp: "",
  //       effectivePeriod: {
  //         asInt: record.effectivePeriod.asInt,
  //         monthShortName: record.effectivePeriod.monthShortName,
  //         period: record.effectivePeriod.period,
  //         start: record.effectivePeriod.start,
  //         year: record.effectivePeriod.year
  //       },
  //       activityItems: this.handleItemRecord(record.activityItems)
  //     })
  //   }
  //   //localStorage.setItem(timeStamp, JSON.stringify(activityRecord));
  //   return activityRecord.reverse();
  // }

  // handleItemRecord(activityItems: ActivityItemResponse[]): LogbookActivityItemRecord[] {
  //   let logbookActivityItems: LogbookActivityItemRecord[] = [];

  //   for (let activityItem of activityItems) {
  //     if (activityItem.activityIdentifier != 24 && activityItem.linkedSequence != null) {
  //       logbookActivityItems.push({
  //         originationDate: activityItem.originationDate,
  //         positionCode: activityItem.positionCode,
  //         activityIdentifier: activityItem.activityIdentifier,
  //         duration: activityItem.duration,
  //         startDateTimeGmt: activityItem.startDateTimeGmt,
  //         startDateTimeLocal: activityItem.startDateTimeLocal,
  //         endDateTimeGmt: activityItem.endDateTimeGmt,
  //         endDateTimeLocal: activityItem.endDateTimeLocal,
  //         activityType: activityItem.activityType,
  //         removalCode: activityItem.removalCode,
  //         linkedSequence: {
  //           sequenceNumber: activityItem.linkedSequence.sequenceNumber,
  //           scheduledFlight: activityItem.linkedSequence.scheduledFlight,
  //           sequenceGreater: activityItem.linkedSequence.sequenceGreater,
  //           sequenceDeadhead: activityItem.linkedSequence.sequenceDeadhead,
  //           sequenceTAFB: activityItem.linkedSequence.sequenceTAFB,
  //           sequenceComplete: activityItem.linkedSequence.sequenceComplete,
  //           dutyPeriodSummaries: this.handleDutyPeriodSummary(activityItem.linkedSequence.dutyPeriodSummaries)
  //         }
  //       })
  //     }
  //   }

  //   return logbookActivityItems.reverse();
  // }

  // handleDutyPeriodSummary(dutySummaries: DutyPeriodSummary[]): LogbookDutyPeriodSummary[] {
  //   let dutySummary: LogbookDutyPeriodSummary[] = []
  //   for (let duty of dutySummaries) {
  //     dutySummary.push({
  //       dutyPeriodIndex: duty.dutyPeriodIndex,
  //       dutyPeriodScheduled: duty.dutyPeriodSchedOnDuty,
  //       dutyPeriodGreater: duty.dutyPeriodGreater,
  //       dutyPeriodDeadhead: duty.dutyPeriodDeadhead,
  //       dutyPeriodSchedOnDuty: duty.dutyPeriodSchedOnDuty,
  //       dutyPeriodFdp: duty.dutyPeriodFdp,
  //       dutyPeriodStartTime: duty.dutyPeriodStartTime,
  //       dutyPeriodStartTimeUtc: duty.dutyPeriodStartTimeUtc,
  //       dutyPeriodEndTime: duty.dutyPeriodEndTime,
  //       dutyPeriodEndTimeUtc: duty.dutyPeriodEndTimeUtc,
  //       dutyPeriodLegs: duty.dutyPeriodLegs,
  //       dutyPeriodActualOnDuty: duty.dutyPeriodActualOnDuty,
  //       layoverStation: duty.layoverStation,
  //       layoverLength: duty.layoverLength,
  //       legs: this.handleLegs(duty.legs)
  //     })
  //   }
  //   return dutySummary.reverse();
  // }

  // handleLegs(legs: Leg[]): LogbookLegs[] {
  //   let logbookLegs: LogbookLegs[] = []
  //   for (let leg of legs) {
  //     if (leg.flightNumber != "0000") {
  //       logbookLegs.push({
  //         index: leg.index,
  //         flightNumber: leg.flightNumber,
  //         depStation: leg.depStation,
  //         depStation_lat: leg.depStation_lat,
  //         depStation_long: leg.depStation_long,
  //         depTimeSched: leg.depTimeSched,
  //         depTimeSchedUTC: leg.depTimeSchedUTC,
  //         depTimeResched: leg.depTimeResched,
  //         depTimeReschedUTC: leg.depTimeReschedUTC,
  //         depTimeActual: leg.depTimeActual,
  //         depTimeActualUTC: leg.depTimeActualUTC,
  //         isDeadhead: leg.isDeadhead,
  //         arrStation: leg.arrStation,
  //         arrStation_lat: leg.arrStation_lat,
  //         arrStation_long: leg.arrStation_long,
  //         arrTimeSched: leg.arrTimeSched,
  //         arrTimeSchedUTC: leg.arrTimeSchedUTC,
  //         arrTimeResched: leg.arrTimeResched,
  //         arrTimeReschedUTC: leg.arrTimeReschedUTC,
  //         arrTimeActual: leg.arrTimeActual,
  //         arrTimeActualUTC: leg.arrTimeActualUTC,
  //         actFlightTimeVsSched: leg.actFlightTimeVsSched,
  //         flightTimeSched: leg.flightTimeSched,
  //         flightTimeActual: leg.flightTimeActual,
  //         passengerCount: leg.passengerCount,
  //         flightDistance: leg.flightDistance,
  //         aircraft: this.handleAircraft(leg.aircraft),
  //         aircraftId: leg.aircraftId,
  //         isActive: leg.isActive,
  //         isCancelled: leg.isCancelled,
  //         cancellationTime: leg.cancellationTime,
  //         crew: this.handleFlightCrew(leg.crew)
  //       })
  //     }
  //   }
  //   return logbookLegs.reverse();
  // }

  // handleAircraft(aircraft: Aircraft): LogbookAircraft {
  //   let aircraftData: LogbookAircraft = {
  //     short: "",
  //     long: ""
  //   };
  //   if (aircraft) {
  //     if (aircraft.short != null || aircraft.long != null) {
  //       aircraftData = {
  //         short: aircraft.short,
  //         long: aircraft.long
  //       }
  //     }
  //   }
  //   return aircraftData;
  // }

  // handleFlightCrew(crews: Crew[]): LogbookFlightCrew[] {
  //   let flightCrew: LogbookFlightCrew[] = [];
  //   for (let crew of crews ) {
  //     flightCrew.push({
  //       employeeNumber: crew.employeeNumber,
  //       seat: crew.seat,
  //     })
  //   }
  //   return flightCrew
  // }

  
